import comp from "./TagsSetupModal";
export default comp;
